import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ToastSnackbarComponent } from "./toast-snackbar.component";

@Injectable({ providedIn: "root" })
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  success(message: string, duration = 5000): void {
    this.snackBar.openFromComponent(ToastSnackbarComponent, {
      duration,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["evta-toast-success"],
      data: { message, icon: "check_circle" },
    });
  }

  error(message: string, duration = 5000): void {
    this.snackBar.openFromComponent(ToastSnackbarComponent, {
      duration,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["evta-toast-error"],
      data: { message, icon: "error" },
    });
  }

  show(status: string, message: string): void {
    if (status === "success") {
      this.success(message);
    } else {
      this.error(message);
    }
  }
}
